import { CardMedia } from '@mui/material';

const LogoName = 'persistence.png';

const logoWidth = '200px';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Persistence Capital Logo"
      sx={{ width: logoWidth, m: 3 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Persistence Capital Logo"
      sx={{ width: '200px', m: 3, my: 2 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Persistence Capital Logo"
      sx={{ width: logoWidth }}
    />
  );
};
